import { getLifecycle } from 'service/utils';

const REDUCER_NAME = 'BUY_BEST_SELLING_ORDERS';

export const BUY_FROM_BEST_SELLING_ORDERBOOK = getLifecycle(REDUCER_NAME, 'BUY_FROM_BEST_SELLING_ORDERBOOK');